module.exports = __webpack_public_path__ + "img/Button_AppStoreOver-smv.6431dfe9.png";